export default __webpack_public_path__ + "static/media/93.48bb6433.jpeg";